import { useI18nContext } from '@/i18n/i18n-react';
import {
  Banknote,
  BarChart,
  MousePointerClick,
  ShoppingCart,
} from 'lucide-react';
import { MetricCard } from '@/components/metric-card';
import { KpiCarousel } from '@/components/metrics/kpi-carousel';
import type { CampaignMetricsGridProps } from '@/components/metrics/metric-sections.types';

export function CampaignMetricsGrid({
  campaignPerformance,
  isLoadingCampaignPerformance,
  isLoadingDataSufficiency,
  dateFilterLabel,
  currency,
  campaignsSufficiency,
}: CampaignMetricsGridProps) {
  const { LL, locale } = useI18nContext();

  return (
    <KpiCarousel desktopClassName="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
      {/* <MetricCard
        title={LL.metricsPage.campaignPerformance.totalOrders.title()}
        value={campaignPerformance?.totalOrderPaidCount ?? '--'}
        icon={<Bell className="h-6 w-6" />}
        description={dateFilterLabel}
        isLoading={isLoadingCampaignPerformance}
        isLoadingDataSufficiency={isLoadingDataSufficiency}
        helpKey="campaignTotalOrders"
        dataSufficiency={campaignsSufficiency}
      />
      <MetricCard
        title={LL.metricsPage.campaignPerformance.totalRevenue.title()}
        value={campaignPerformance?.totalRevenue ?? '--'}
        currency={currency}
        icon={<Banknote className="h-6 w-6" />}
        description={dateFilterLabel}
        isLoading={isLoadingCampaignPerformance}
        isLoadingDataSufficiency={isLoadingDataSufficiency}
        helpKey="campaignTotalRevenue"
        dataSufficiency={campaignsSufficiency}
      /> */}
      <MetricCard
        title={LL.metricsPage.notificationConversion.title()}
        value={
          campaignPerformance?.averageConversionRate != null
            ? new Intl.NumberFormat(locale, {
                style: 'percent',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(campaignPerformance.averageConversionRate)
            : '--'
        }
        icon={<ShoppingCart className="h-6 w-6" />}
        description={dateFilterLabel}
        isLoading={isLoadingCampaignPerformance}
        isLoadingDataSufficiency={isLoadingDataSufficiency}
        helpKey="notificationConversion"
        dataSufficiency={campaignsSufficiency}
      />
      <MetricCard
        title={LL.metricsPage.campaignPerformance.averageCtr.title()}
        value={
          campaignPerformance?.averageCtr != null
            ? new Intl.NumberFormat(locale, {
                style: 'percent',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(campaignPerformance.averageCtr)
            : '--'
        }
        icon={<MousePointerClick className="h-6 w-6" />}
        description={dateFilterLabel}
        isLoading={isLoadingCampaignPerformance}
        isLoadingDataSufficiency={isLoadingDataSufficiency}
        helpKey="campaignAverageCtr"
        dataSufficiency={campaignsSufficiency}
      />
      <MetricCard
        title={LL.metricsPage.campaignPerformance.averageClicks.title()}
        value={campaignPerformance?.averageClicks ?? '--'}
        icon={<BarChart className="h-6 w-6" />}
        description={dateFilterLabel}
        isLoading={isLoadingCampaignPerformance}
        isLoadingDataSufficiency={isLoadingDataSufficiency}
        helpKey="campaignAverageClicks"
        dataSufficiency={campaignsSufficiency}
      />
      {/* ANLT-05: `averageRevenue` of /metrics/campaigns. */}
      <MetricCard
        title={LL.metricsPage.pushTab.averageRevenue()}
        value={campaignPerformance?.averageRevenue ?? '--'}
        currency={currency}
        icon={<Banknote className="h-6 w-6" />}
        description={dateFilterLabel}
        isLoading={isLoadingCampaignPerformance}
        isLoadingDataSufficiency={isLoadingDataSufficiency}
        helpKey="averageCampaignRevenue"
        dataSufficiency={campaignsSufficiency}
      />
    </KpiCarousel>
  );
}
